import { render, staticRenderFns } from "./action-channel-komchat-modal.vue?vue&type=template&id=baf2dad2&"
import script from "./action-channel-komchat-modal.vue?vue&type=script&lang=js&"
export * from "./action-channel-komchat-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports